import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { US_STATES } from '../../shared/models/us-states';
import { ToastrService } from 'ngx-toastr';
import { InsureApiService } from '../../shared/services/insure-api.service';
import { environment } from '../../../environments/environment';

interface ContactReason {
  value: string;
  label: string;
  toEmail: string;
}

@Component({
  selector: 'ins-contact',
  templateUrl: './contact.component.html',
})
export class ContactComponent implements OnInit {
  contactForm!: FormGroup;
  states = US_STATES;
  contactSubmitted = false;
  captchaIsValid = false;
  captchaResponse = '';
  captchaKey = environment.RecaptchaSiteKey;

  reasons: ContactReason[] = [
    {
      value: '1',
      label: 'Claim Related Question',
      toEmail: 'Claims@dfsinsure.com',
    },
    {
      value: '2',
      label: 'Policy Renewals or Requests',
      toEmail: 'Renewals@dfsinsure.com',
    },
    {
      value: '3',
      label: 'Agent Related Question',
      toEmail: 'InsuranceDocs@dfsinsure.com',
    },
    {
      value: '4',
      label: 'General Inquiry',
      toEmail: 'InsuranceDocs@dfsinsure.com',
    },
  ];

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private insureApi: InsureApiService,
  ) {}

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      reason: ['', Validators.required],
      name: ['', Validators.required],
      address: [''],
      city: [''],
      state: [''],
      zipCode: [''],
      policyNumber: [''],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit(): void {
    this.contactSubmitted = true;
    this.contactForm.markAllAsTouched();
    if (this.contactForm.invalid || !this.captchaIsValid) {
      return;
    }

    const form = this.contactForm.value;
    const selectedReason = this.reasons.find((r) => r.value === form.reason);
    if (!selectedReason) return;

    let body = `${selectedReason.label} has been submitted.<br>`;
    body += `Name: ${form.name} can be reached at ${form.email}<br>`;
    if (form.address) body += `Address: ${form.address}<br>`;
    if (form.city) body += `City: ${form.city}<br>`;
    if (form.state) body += `State: ${form.state}<br>`;
    if (form.zipCode) body += `Zip Code: ${form.zipCode}<br>`;
    if (form.policyNumber) body += `Policy Number: ${form.policyNumber}<br>`;

    this.insureApi
      .sendEmail({
        toAddresses: [selectedReason.toEmail],
        subject: selectedReason.label,
        bodyHtml: body,
      })
      .subscribe({
        next: () => {
          this.toastr.success(
            'Your message has been sent. We will be in touch shortly.',
          );
          this.contactForm.reset();
          this.contactSubmitted = false;
          this.captchaIsValid = false;
          this.captchaResponse = '';
        },
        error: () => {
          this.toastr.error(
            'There was a problem sending your message. Please try again.',
          );
        },
      });
  }

  getCaptchaValue(captcha: string | null): void {
    this.captchaIsValid = !(captcha === null || captcha === undefined);
    this.captchaResponse = captcha || '';
  }
}
